import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type BasicEventInfoByIdQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  isAdmin?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;

export type BasicEventInfoByIdQuery = {
  __typename?: 'Query';
  eventById?: {
    __typename?: 'Event';
    id: string;
    firebaseId: string;
    published: boolean;
    websiteState: Types.EventWebsiteState;
    featureFlags?: Array<string | null> | null;
    info: {
      __typename?: 'EventInfo';
      id: string;
      eventDisplayName?: string | null;
      hasEventPassword: boolean;
      eventType: Types.EventType;
      usesNewStack: boolean;
      fianceeFirstName?: string | null;
      fianceeLastName?: string | null;
      ownerFirstName?: string | null;
      ownerLastName?: string | null;
      locale: string;
      guestDisplayLocales?: Array<string> | null;
      clockFormat?: Types.ClockFormat | null;
      story?: string | null;
      locationInfo?: {
        __typename?: 'EventLocation';
        id?: string | null;
        city?: string | null;
        country?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        name?: string | null;
        placeId?: string | null;
        state?: string | null;
        address1?: string | null;
        address2?: string | null;
        postalCode?: string | null;
      } | null;
      finalizedDate?: { __typename?: 'Date'; milliseconds: number; dateString: string; timestamp: any; timezone: string } | null;
      tentativeDate?: { __typename?: 'Date'; milliseconds: number; dateString: string; timestamp: any; timezone: string } | null;
      dateMetadata?: {
        __typename?: 'EventDateMetadata';
        customText?: string | null;
        dateDisplayType: Types.DateDisplayType;
        dateFormat?: string | null;
        dateRangeFormat?: string | null;
      } | null;
      startDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string } | null;
      endDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string } | null;
      qanda: Array<{ __typename?: 'EventQanda'; id: string; type: Types.QandaType; question: string; answer: string }>;
    };
    firebaseCreateAt?: { __typename?: 'Date'; timestamp: any } | null;
    createdAt: { __typename?: 'Date'; timestamp: any };
    productVerticals?: {
      __typename?: 'EventProductVerticals';
      id: string;
      optOutOfGuestList?: boolean | null;
      optOutOfInvites?: boolean | null;
      optOutOfRegistry?: boolean | null;
      optOutOfWebsite?: boolean | null;
    } | null;
    settings: {
      __typename?: 'EventSettings';
      id: string;
      hideEventCountdown: boolean;
      hideDownloadAppPage: boolean;
      hideFromSearchEngines: boolean;
      hideFromJoySearch: boolean;
      requirePasswordForEventDate: boolean;
      requirePasswordForEventLocation: boolean;
      requirePasswordToUploadPhotos: boolean;
      requirePasswordToViewEngagementPhotos: boolean;
      privacyMode: Types.PrivacyModeType;
      optOutOfCharm: boolean;
      allowFacebookAndInstagramSharingOnApp: boolean;
      allowGuestsNotInGuestListToRSVP: boolean;
      allowGuestsToInviteOtherGuestsOnApp: boolean;
      allowGuestsToRSVPPlusOne: boolean;
      allowGuestsToViewOtherGuestsOnApp: boolean;
      requiresGuestIdentification: boolean;
    };
  } | null;
};

export const BasicEventInfoByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BasicEventInfoById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isAdmin' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BasicEventInfoFields' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasicEventInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'info' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'isAdmin' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasEventPassword' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usesNewStack' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fianceeLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestDisplayLocales' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clockFormat' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalizedDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateString' },
                        arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'long' } }],
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tentativeDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateString' },
                        arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'long' } }],
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateMetadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'customText' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateDisplayType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateFormat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateRangeFormat' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateString' },
                        arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'long' } }],
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'endDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateString' },
                        arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'long' } }],
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'story' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'qanda' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventQanda' } }] },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firebaseCreateAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productVerticals' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfGuestList' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfInvites' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfRegistry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfWebsite' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideEventCountdown' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideDownloadAppPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideFromSearchEngines' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideFromJoySearch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirePasswordForEventDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirePasswordForEventLocation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirePasswordToUploadPhotos' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirePasswordToViewEngagementPhotos' } },
                { kind: 'Field', name: { kind: 'Name', value: 'privacyMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optOutOfCharm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowFacebookAndInstagramSharingOnApp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowGuestsNotInGuestListToRSVP' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowGuestsToInviteOtherGuestsOnApp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowGuestsToRSVPPlusOne' } },
                { kind: 'Field', name: { kind: 'Name', value: 'allowGuestsToViewOtherGuestsOnApp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiresGuestIdentification' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureFlags' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventQanda' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventQanda' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'question' } },
          { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useBasicEventInfoByIdQuery__
 *
 * To run a query within a React component, call `useBasicEventInfoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicEventInfoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicEventInfoByIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useBasicEventInfoByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BasicEventInfoByIdQuery, BasicEventInfoByIdQueryVariables>) {
  return ApolloReactHooks.useQuery<BasicEventInfoByIdQuery, BasicEventInfoByIdQueryVariables>(BasicEventInfoByIdDocument, baseOptions);
}
export function useBasicEventInfoByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BasicEventInfoByIdQuery, BasicEventInfoByIdQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<BasicEventInfoByIdQuery, BasicEventInfoByIdQueryVariables>(BasicEventInfoByIdDocument, baseOptions);
}
export type BasicEventInfoByIdQueryHookResult = ReturnType<typeof useBasicEventInfoByIdQuery>;
export type BasicEventInfoByIdLazyQueryHookResult = ReturnType<typeof useBasicEventInfoByIdLazyQuery>;
export type BasicEventInfoByIdQueryResult = Apollo.QueryResult<BasicEventInfoByIdQuery, BasicEventInfoByIdQueryVariables>;
